module.exports = __webpack_public_path__ + "img/compass.f4ec1284.gif";